import { createSlice } from '@reduxjs/toolkit';

const promptsSlice = createSlice({
    name: 'prompts',
    initialState: { selectedPrompt: {}, userPrompts: [] },

    reducers: {
        setSelectedPrompt: (state, action) => {
            state.selectedPrompt = action.payload;
        },
        clearSelectedPrompt: (state) => {
            state.selectedPrompt = [];
        },
        setUserPrompts: (state, action) => {
            state.userPrompts = action.payload;
        },
        insertSavedPrompt: (state, action) => {
            const newPrompt = action.payload.data;
            state.userPrompts.push(newPrompt);
        },
        deleteSavedPrompt: (state, action) => {
            const deletedPromptId = action.payload;
            // Locate the state.preferences.prompts array and remove the prompt with the id of deletedPromptId
            state.userPrompts = state.userPrompts.filter(
                (prompt) => prompt.id !== deletedPromptId,
            );
        },
        updateSavedPrompt: (state, action) => {
            const updatedPrompt = action.payload.data;

            const promptIndex = state.userPrompts.findIndex(
                (prompt) => prompt.id === updatedPrompt.id,
            );

            if (promptIndex !== -1) {
                state.userPrompts[promptIndex] = updatedPrompt;
            }
        },
        clearUserPrompts: (state) => {
            state.userPrompts = []
        },
    },
});

export const {
    setSelectedPrompt,
    clearSelectedPrompt,
    setUserPrompts,
    clearUserPrompts,
    insertSavedPrompt,
    deleteSavedPrompt,
    updateSavedPrompt
} = promptsSlice.actions;
export default promptsSlice.reducer;
